import React from 'react';
import Select from 'react-select';
import Datepicker from 'react-datepicker';
import Moment from 'moment';
import Toaster from 'toastr';
import FloatInput from '../../common/floatInput';
import { permissioned } from '../../common/permissionedHoc';
import Constants from '../../../configurations/constants';
import Util from '../../../util/util';
import Messages from '../../../configurations/messages';
import ErrorLabel from '../../common/errorLabel';
import ArbiterApi from '../../../api/ArbiterApi';

class NewClaimTxnFilter extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            txnType: null,
            identifier: "",
            fromDate: Moment(),
            toDate: Moment(),
            stan: '',
            retrievalReferenceNumber: '',
            terminalId: '',
            toAccount: '',
            validity: {
                identifier: true,
                fromDate: true,
                toDate: true,
                dateRange: true,
                txnType: true
            },
            transactionGroups: [],
            currentTransactionGroup: null,
            transactionGroupFilters: [],
            channels: [],
            selectedChannel: null,
            searchButtonDisabled: true,
            touchedForm: false,
            advancedOptionsVisible: false,
        };
        this.onTxnTypeChange = this.onTxnTypeChange.bind(this);
        this.onTextInputChange = this.onTextInputChange.bind(this);
        this.onFromDateChange = this.onFromDateChange.bind(this);
        this.onToDateChange = this.onToDateChange.bind(this);
        this.onSearchHandler = this.onSearchHandler.bind(this);
        this.onAdvanceOptionsChanged = this.onAdvanceOptionsChanged.bind(this);
        this.onTxnIdentifierChange = this.onTxnIdentifierChange.bind(this);
    }
    componentDidMount() {
        ArbiterApi.getTransactionGroups()
            .then(response => {
                let data = response.data;
                let groups = data || [];
                //Map groups to support the select field e.g add label and value properties
                groups = groups.map(item => {
                    item.label = item.name;
                    item.value = item.name;
                    return item;
                });
                this.setState({ transactionGroups: groups });
            })
            .catch(error => {
                console.log(error);
                Toaster.error(`${error.statusText}`, `${Messages.ERROR_TRANSACTION_GROUPS} - ${error.data ? error.data.description : error.statusText}`);
            });
    }
    componentDidUpdate(prevProps, prevState) {
        //Set Search button to be enabled (Initial State = 'disabled')
        if (this.state.searchButtonDisabled && prevState.identifierType === this.state.identifierType) //Select txn type was not the control value  changed
            this.setState({ searchButtonDisabled: false });
    }
    onChannelChange(selectedChannel) {
        let filters = [];
        //Generate array filters
        let filterGroupSize = 4;
        if (selectedChannel && selectedChannel.additionalParameters) {
            let numberOfFilterGroups = Math.ceil(selectedChannel.additionalParameters.length / filterGroupSize);
            for (let i = 0; i < numberOfFilterGroups; i++) {
                filters.push((selectedChannel.additionalParameters.slice(filterGroupSize * i, filterGroupSize * (i + 1))));
            }
        }
    }

    onTxnIdentifierChange(event) {
        let clearVal = event.target.value;
        let val = event.target.name === Constants.TXN_IDENTIFIER_PAN.name ? Util.maskPan(clearVal) : clearVal;
        let valid = this.validateInputField(event.target.name, val, false);
        let stateUpdate = {
            identifier: val,
            validity: this.setValidityAndReturn("identifier", valid)
        };
        this.setState(stateUpdate);

    }
    onAdvanceOptionsChanged(event) {
        this.clearAdvancedInputs();
        this.setState({ advancedOptionsVisible: event.target.checked });
    }

    onTextInputChange(event) {
        let value = event.target.value;
        let valid = this.validateInputField(event.target.name, value, true)
        let stateUpdate = {};
        stateUpdate[event.target.name] = value;
        stateUpdate.touchedForm = true;
        stateUpdate.validity = this.setValidityAndReturn(event.target.name, valid);
        this.setState(stateUpdate);
    }

    onFromDateChange(date) {
        //Set the 'toDate' to maximum date. Set validity for dates to 'true'
        let maxDate = date.clone();
        maxDate.add(Constants.MAX_DATE_RANGE_MONTHS, 'months');
        let validity = this.setValidityAndReturn("fromDate", true);
        validity.dateRange = true;
        validity.toDate = true;
        this.setState({ fromDate: date.startOf('day'), toDate: maxDate, validity: validity, touchedForm: true });

    }
    onToDateChange(date) {

        let valid = date != null;
        let validDateRange = true;

        //Validate that from date isn't less than specified  month range
        if (this.state.fromDate) {
            let maxDate = date.clone();
            maxDate.subtract(Constants.MAX_DATE_RANGE_MONTHS, 'months');
            valid = (date.unix() >= this.state.fromDate.unix());
            validDateRange = (maxDate.unix() <= this.state.fromDate.unix());
        }
        let validity = this.setValidityAndReturn("toDate", valid);
        validity.dateRange = validDateRange;

        this.setState({ toDate: date.endOf('day'), validity: validity , touchedForm : true});
    }
    onSearchHandler() {
        //TODO: validate control values
        //If  empty currentTransactionGroup or identifier
        if (!this.state.currentTransactionGroup || !this.state.identifier) {
            let validityState = this.setValidityAndReturn("currentTransactionGroup", !!this.state.currentTransactionGroup);
            validityState.identifier = !!this.state.identifier;
            this.setState({ validity: validityState });
            return;
        }

        //If  empty channel
        if (!this.state.selectedChannel) {
            let validityState = this.setValidityAndReturn("selectedChannel", !!this.state.selectedChannel);
            this.setState({ validity: validityState });
            return;
        }

        //Build Params
        let params = {};
        let currentTransactionGroup = this.state.currentTransactionGroup;
        let selectedChannel = this.state.selectedChannel;


        //Additional Params
        if (selectedChannel.additionalParameters) {
            selectedChannel.additionalParameters.forEach(param => {
                let val = this.state[param];
                if (val)
                    params[param] = val;
            })
        }

        //Query Params
        params[selectedChannel.customerReference] = this.state.identifier;

        //date params
        params.startDate = this.state.fromDate ? this.state.fromDate.format(Constants.DATE_FORMAT_LONG) : null;
        params.endDate = this.state.toDate ? this.state.toDate.endOf('day').format(Constants.DATE_FORMAT_LONG) : null;

        this.props.onSearchHandler && this.props.onSearchHandler(currentTransactionGroup.name, selectedChannel.channel, params);
    }
    onTxnTypeChange(event) {
        let filters = [];
        this.clearAdvancedInputs();

        //Map channels
        let channels = !event || !event.channels ? [] : event.channels.map(c => {
            let channel = event.groups[c];
            channel.label = channel.channel;
            channel.value = channel.channel;
            return channel;
        });

        //Select first channel if only one chennel in the list
        let selectedChannel = channels.length === 1 ? channels[0] : null;

        //Generate array filters
        let filterGroupSize = 4;

        if (selectedChannel && selectedChannel.additionalParameters) {
            let numberOfFilterGroups = Math.ceil(selectedChannel.additionalParameters.length / filterGroupSize);
            for (let i = 0; i < numberOfFilterGroups; i++) {
                filters.push((selectedChannel.additionalParameters.slice(filterGroupSize * i, filterGroupSize * (i + 1))));
            }
        }
        let validity = this.setValidityAndReturn("txnType", event ? !!event.value : false);
        validity.identifier = true;
        this.setState({
            txnType: event ? event.name : '',
            currentTransactionGroup: event,
            transactionGroupFilters: filters,
            identifier: '',
            selectedChannel: selectedChannel,
            channels: channels,
            category: null,
            validity,
            touchedForm : true
        });

    }

    render() {

        return (
            <form onSubmit={(e) => { this.onSearchHandler(); e.preventDefault(); return false; }}>
                <div>
                    <div className="row filters">
                        <div className="col-md-3">
                            <Select
                                name="txnType"
                                placeholder="Tran. Group"
                                value={this.state.txnType}
                                options={this.state.transactionGroups}
                                onChange={this.onTxnTypeChange}
                            />
                            {!this.state.validity.txnType && <ErrorLabel message={Messages.INVALID_TXN_TYPE} />}
                        </div>
                        <div className="col-md-3">
                            <Select
                                name="channel"
                                placeholder="Channel"
                                value={this.state.selectedChannel}
                                options={this.state.channels}

                            />
                            {!this.state.validity.txnType && <ErrorLabel message={Messages.INVALID_CHANNEL} />}
                        </div>

                        <div className=" col-md-2 ">
                            <span>
                                <label className="input-control-label">From:</label>
                                <br />
                                <Datepicker
                                    onChange={this.onFromDateChange}
                                    className="input-control"
                                    id="fromDate"
                                    placeHolderText="From Date"
                                    disabledKeyboardNavigation
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    dateFormat={Constants.DATE_FORMAT}
                                    selected={this.state.fromDate} />
                            </span>
                            <br />
                            {
                                (!this.state.validity.fromDate || !this.state.validity.dateRange) &&
                                <ErrorLabel message={!this.state.validity.dateRange ? Messages.INVALID_DATE_RANGE : Messages.INVALID_START_DATE} />
                            }
                        </div>

                        <div className=" col-md-2">
                            <span>
                                <label className="input-control-label">To:</label>
                                <br />
                                <Datepicker
                                    onChange={this.onToDateChange}
                                    id="toDate"
                                    className="input-control"
                                    dateFormat={Constants.DATE_FORMAT}
                                    placeHolderText="To Date"
                                    disabledKeyboardNavigation
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    minDate={this.state.fromDate}
                                    maxDate={this.state.fromDate ? this.state.fromDate.clone().add(Constants.MAX_DATE_RANGE_MONTHS, 'months') : Moment()}
                                    selected={this.state.toDate} />
                            </span>
                            <br />
                            {
                                (!this.state.validity.toDate || !this.state.validity.dateRange) &&
                                <ErrorLabel message={!this.state.validity.dateRange ? Messages.INVALID_DATE_RANGE : Messages.INVALID_END_DATE} />
                            }
                        </div>

                        <div className=" col-md-2">
                            <button
                                disabled={this.state.searchButtonDisabled || !this.isValidForm()}
                                className="btn btn-primary"
                                type="submit">
                                Search
                        </button>
                        </div>

                    </div>
                    <div className="row filters">
                        <div className="col-md-3">
                            <FloatInput
                                id="identifier"
                                name={this.state.selectedChannel ? this.state.selectedChannel.customerReference : "identifier"}
                                value={this.state.identifier}
                                onChange={this.onTxnIdentifierChange}
                                required={true}
                                placeholder={this.state.selectedChannel ? `Enter ${Util.regularFormString(this.state.selectedChannel.customerReference)}` : 'Tran. Identifier'}
                                showError={!this.state.validity.identifier} errorMessage={`${Messages.INVALID_IDENTIFIER} ${Util.regularFormString(this.state.selectedChannel ? this.state.selectedChannel.customerReference : "identifier")}`} />
                        </div>
                    </div>

                    <div style={{ textAlign: 'right' }}>
                        <div className="checkbox">
                            <label>
                                <input type="checkbox" id="advancedCheckBox" onChange={this.onAdvanceOptionsChanged} />
                                <span className="lbl"
                                    checked={this.state.advancedOptionsVisible}
                                >Advanced Options</span>
                            </label>
                        </div>
                    </div>
                    {this.state.advancedOptionsVisible && this.state.transactionGroupFilters.map((filterArray, index) => {

                        return (
                            <div key={index} className="row filters">
                                {
                                    filterArray.map(filter => {
                                        return (
                                            <div key={filter} className="col-md-3">
                                                <FloatInput
                                                    value={this.state[filter]}
                                                    onChange={this.onTextInputChange}
                                                    id={filter}
                                                    name={filter}
                                                    showError={this.state.validity[filter] === false}
                                                    errorMessage={``}
                                                    placeholder={Util.regularFormString(filter)} />

                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )
                    })
                    }
                </div>
            </form>
        );
    }



    isValidForm() {
        if(!this.state.touchedForm)
            return false;
        let isValid = true;
        for (let i in this.state.validity)
            isValid &= this.state.validity[i];

        return isValid;
    }

    setValidityAndReturn(fieldId, validity) {
        let validityState = Object.assign({}, this.state.validity);
        validityState[fieldId] = validity;
        return validityState;

    }
    clearAdvancedInputs() {
        let validity = Object.assign({}, this.state.validity);
        let stateUpdate = {};
        let selectedChannel = this.state.selectedChannel;
        if (selectedChannel) {
            selectedChannel.additionalParameters && selectedChannel.additionalParameters.forEach(filter => {
                validity[filter] = true;
                stateUpdate[filter] = "";
            })
        }
        stateUpdate.validity = validity;
        this.setState(stateUpdate);
    }

    validateInputField(field, value, allowEmpty) {
        let isValid = true;

        if (!value && allowEmpty)
            return isValid;

        switch (field) {
            case Constants.TXN_IDENTIFIER_PAN.name:
                isValid = Constants.REG_EXPR_VALID_PAN.test(value)
                break;
            case Constants.TXN_IDENTIFIER_PAYCODE.name:
                isValid = Constants.REG_EXPR_VALID_DIGITS.test(value)
                break;
            default:
                isValid = !!value;
        }

        return isValid;

    }
}

export default permissioned(NewClaimTxnFilter);


// WEBPACK FOOTER //
// ./src/components/disputeMgmt/newClaim/newClaimTxnFilter.js